export enum AttendeeVisibility {
    Never = 0,
    OnCreation = 1,
    WhenLive = 2,
    AfterFinished = 3
}